import {Component, React, observer, resolveCss} from '$src/handy'
import * as css from './EditLocationModal.css'
import GenericModal from '$src/common/GenericModal'
import {Form} from '$src/common/forms'
import TextInput from '$src/common/TextInput'
import GenericButton from '$src/common/GenericButton'
import {getSnapshot} from 'mobx-state-tree'
import editHousingCorporationComment from '$src/api/endpoints/housingCorporations/editHousingCorporationComment'

interface Props {
  onRequestClose: Function
  cid: string | number
  onUpdateNeeded: Function
}

interface State {
  error?: string
  submitting: boolean
}

@observer
export default class EditCommentModal extends Component<Props, State> {
  constructor(props: Props, context: any) {
    super(props, context)

    this.state = {error: undefined, submitting: false}
  }

  onSubmit = (fields: any) => {
    this.setState({error: undefined, submitting: true})

    this.callEndpoint(editHousingCorporationComment, {
      comment: fields.comment,
      cid: this.props.cid,
    }).then(
      () => {
        this.setState({submitting: false})
        this.props.onUpdateNeeded(fields.comment)
        this.props.onRequestClose()
      },
      (error: any) => {
        this.setState(s => ({...s, error: error.message || 'Unauthorized', submitting: false}))
      },
    )
  }

  render() {
    const {props} = this
    // const classes = resolveCss(css)
    let initialValues = undefined
    const data: {comment?: string} = getSnapshot(
      // @ts-ignore
      this.store.housingCorporations.byId.get(props.cid as any),
    )
    initialValues = {
      comment: data.comment,
    }

    return (
      <GenericModal onHide={props.onRequestClose} css={{box: {container: css.box}}}>
        <Form onSubmit={this.onSubmit} initialValues={initialValues}>
          <TextInput.Field name="comment" type="text" label="COMMENT" />
          <div className={css.bottom}>
            {this.state.error && <div className={css.error}>Error occured: {this.state.error}</div>}
            <GenericButton variant="bold" type="submit" disabled={this.state.submitting}>
              EDIT Comment
            </GenericButton>
          </div>
        </Form>
      </GenericModal>
    )
  }
}



// WEBPACK FOOTER //
// ./src/housingCorporations/EditCommentModal.tsx